export default __webpack_public_path__ + "static/media/marketplace-grey.082f0a2f.svg";